import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import {
  Col, Heading, InsetText, Row,
} from 'idsk-react-components';
import { BackLink } from 'slovlex-idsk-react-components';
import PredpisyCudziJazykTableComponent from './component/PredpisyCudziJazykTableComponent';
import PredpisCudziJazyk from '../../model/PredpisCudziJazyk';
import './predpisyCudziJazyk.scss';
import routes from '../../routing/routes';

interface Props {
  id: string,
  totalElements: number,
  predpisyCudziJazyk?: PredpisCudziJazyk,
}

const PredpisyCudziJazyk = (
  { id, totalElements, predpisyCudziJazyk }
: Props,
): ReactElement => (
  <div className="predpisy-cudzi-jazyk">
    <div className="back-link-wrapper">
      <BackLink to={routes.pravnePredpisy.to}>
        Späť
      </BackLink>
    </div>
    <Heading
      className="page-heading"
      size="xl"
      dangerouslySetInnerHTML={
          {
            __html: DOMPurify.sanitize(
              predpisyCudziJazyk?.nadpisStrankaCudzi || predpisyCudziJazyk?.nadpisStrankaSk || '',
            ),
          }
        }
    />
    <Row className="main">
      <Col width="two-thirds">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            predpisyCudziJazyk?.popisCudziJazyk || predpisyCudziJazyk?.popisSk || '',
          ),
        }}
        />
        {(predpisyCudziJazyk?.upozornenieCudziJazyk || predpisyCudziJazyk?.upozornenieSk) && (
          <InsetText type="warn-info">
            <strong>
              {/* eslint-disable-next-line react/no-danger */}
              <span dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  predpisyCudziJazyk?.upozornenieCudziJazyk || predpisyCudziJazyk?.upozornenieSk || '',
                ),
              }}
              />
            </strong>
          </InsetText>
        )}
      </Col>
    </Row>
    <PredpisyCudziJazykTableComponent
      id={id}
      totalElements={totalElements}
      predpisyCudziJazyk={predpisyCudziJazyk}
    />
  </div>
);

export default PredpisyCudziJazyk;
